import React, { useState, useEffect } from 'react';
import ProductGrid from '../productgrid';
import '../styles/products.css';

const Products = ({ products }) => {
  // Use localStorage or sessionStorage to persist state
  const [currentPage, setCurrentPage] = useState(() => {
    const savedPage = sessionStorage.getItem('currentProductPage');
    return savedPage ? parseInt(savedPage) : 1;
  });
  
  const [selectedCategory, setSelectedCategory] = useState(() => {
    return sessionStorage.getItem('selectedProductCategory') || 'all';
  });
  
  const productsPerPage = 9;

  // Save state to sessionStorage whenever it changes
  useEffect(() => {
    sessionStorage.setItem('currentProductPage', currentPage.toString());
    sessionStorage.setItem('selectedProductCategory', selectedCategory);
  }, [currentPage, selectedCategory]);

  // Extract unique categories from products
  const categories = ['all', ...new Set(products.map(p => p.category))];

  // Filter products based on selected category
  const filteredProducts = selectedCategory === 'all' 
    ? products 
    : products.filter(p => p.category === selectedCategory);

  // Calculate pagination
  const indexOfLastProduct = currentPage * productsPerPage;
  const indexOfFirstProduct = indexOfLastProduct - productsPerPage;
  const currentProducts = filteredProducts.slice(indexOfFirstProduct, indexOfLastProduct);
  const totalPages = Math.ceil(filteredProducts.length / productsPerPage);

  // Ensure currentPage is valid when category changes or on initial load
  useEffect(() => {
    if (currentPage > totalPages && totalPages > 0) {
      setCurrentPage(totalPages);
    }
  }, [selectedCategory, totalPages, currentPage]);

  const handlePageChange = (pageNumber) => {
    setCurrentPage(pageNumber);
    window.scrollTo(0, 0);
  };

  return (
    <div className="products-container">
      {/* Left Sidebar */}
      <div className="categories-sidebar">
        <h3>Categories</h3>
        <ul>
          {categories.map(category => (
            <li 
              key={category}
              className={selectedCategory === category ? 'active' : ''}
              onClick={() => {
                setSelectedCategory(category);
                setCurrentPage(1);
              }}
            >
              {category.charAt(0).toUpperCase() + category.slice(1)}
            </li>
          ))}
        </ul>
      </div>

      {/* Right Content Area */}
      <div className="products-content">
        <div className="products-header">
          <h1>Our Products</h1>
          <div className="products-count">
            {filteredProducts.length} products
          </div>
        </div>

        <ProductGrid 
          products={currentProducts}
          layout="grid-3"
          showViewMore={false}
        />

        {/* Pagination */}
        {totalPages > 1 && (
          <div className="pagination">
            {Array.from({ length: totalPages }, (_, i) => i + 1).map(number => (
              <button
                key={number}
                className={`page-number ${currentPage === number ? 'active' : ''}`}
                onClick={() => handlePageChange(number)}
              >
                {number}
              </button>
            ))}
          </div>
        )}
      </div>
    </div>
  );
};

export default Products;